import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @title={{i18n "user.second_factor_backup.title"}}
  @closeModal={{@closeModal}}
  class="second-factor-backup-edit-modal"
>
  <:body>
    {{#if this.successMessage}}
      <div class="alert alert-success">
        {{this.successMessage}}
      </div>
    {{/if}}

    {{#if this.errorMessage}}
      <div class="alert alert-error">
        {{this.errorMessage}}
      </div>
    {{/if}}

    <ConditionalLoadingSection @isLoading={{this.loading}}>
      {{#if this.backupCodes}}
        <h3>{{i18n "user.second_factor_backup.codes.title"}}</h3>
        <p>{{i18n "user.second_factor_backup.codes.description"}}</p>
        <BackupCodes
          @copyBackupCode={{this.copyBackupCode}}
          @backupCodes={{this.backupCodes}}
        />
      {{/if}}
    </ConditionalLoadingSection>

    {{#if this.backupEnabled}}
      {{html-safe
        (i18n
          "user.second_factor_backup.remaining_codes" count=this.remainingCodes
        )
      }}
    {{else}}
      {{html-safe (i18n "user.second_factor_backup.not_enabled")}}
    {{/if}}
  </:body>
  <:footer>
    <div class="actions">
      {{#if this.backupEnabled}}
        <DButton
          class="btn-primary"
          @icon="redo"
          @action={{this.generateSecondFactorCodes}}
          @type="submit"
          @isLoading={{this.loading}}
          @label="user.second_factor_backup.regenerate"
        />
      {{else}}
        <DButton
          class="btn-primary"
          @action={{this.generateSecondFactorCodes}}
          @type="submit"
          @disabled={{this.loading}}
          @label="user.second_factor_backup.enable"
        />
      {{/if}}
    </div>
  </:footer>
</DModal>
*/
{
  "id": "qdJq14tP",
  "block": "[[[8,[39,0],[[24,0,\"second-factor-backup-edit-modal\"]],[[\"@title\",\"@closeModal\"],[[28,[37,1],[\"user.second_factor_backup.title\"],null],[30,1]]],[[\"body\",\"footer\"],[[[[1,\"\\n\"],[41,[30,0,[\"successMessage\"]],[[[1,\"      \"],[10,0],[14,0,\"alert alert-success\"],[12],[1,\"\\n        \"],[1,[30,0,[\"successMessage\"]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"errorMessage\"]],[[[1,\"      \"],[10,0],[14,0,\"alert alert-error\"],[12],[1,\"\\n        \"],[1,[30,0,[\"errorMessage\"]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"],[8,[39,3],null,[[\"@isLoading\"],[[30,0,[\"loading\"]]]],[[\"default\"],[[[[1,\"\\n\"],[41,[30,0,[\"backupCodes\"]],[[[1,\"        \"],[10,\"h3\"],[12],[1,[28,[35,1],[\"user.second_factor_backup.codes.title\"],null]],[13],[1,\"\\n        \"],[10,2],[12],[1,[28,[35,1],[\"user.second_factor_backup.codes.description\"],null]],[13],[1,\"\\n        \"],[8,[39,4],null,[[\"@copyBackupCode\",\"@backupCodes\"],[[30,0,[\"copyBackupCode\"]],[30,0,[\"backupCodes\"]]]],null],[1,\"\\n\"]],[]],null],[1,\"    \"]],[]]]]],[1,\"\\n\\n\"],[41,[30,0,[\"backupEnabled\"]],[[[1,\"      \"],[1,[28,[35,5],[[28,[37,1],[\"user.second_factor_backup.remaining_codes\"],[[\"count\"],[[30,0,[\"remainingCodes\"]]]]]],null]],[1,\"\\n\"]],[]],[[[1,\"      \"],[1,[28,[35,5],[[28,[37,1],[\"user.second_factor_backup.not_enabled\"],null]],null]],[1,\"\\n\"]],[]]],[1,\"  \"]],[]],[[[1,\"\\n    \"],[10,0],[14,0,\"actions\"],[12],[1,\"\\n\"],[41,[30,0,[\"backupEnabled\"]],[[[1,\"        \"],[8,[39,6],[[24,0,\"btn-primary\"]],[[\"@icon\",\"@action\",\"@type\",\"@isLoading\",\"@label\"],[\"redo\",[30,0,[\"generateSecondFactorCodes\"]],\"submit\",[30,0,[\"loading\"]],\"user.second_factor_backup.regenerate\"]],null],[1,\"\\n\"]],[]],[[[1,\"        \"],[8,[39,6],[[24,0,\"btn-primary\"]],[[\"@action\",\"@type\",\"@disabled\",\"@label\"],[[30,0,[\"generateSecondFactorCodes\"]],\"submit\",[30,0,[\"loading\"]],\"user.second_factor_backup.enable\"]],null],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"]],[]]]]]],[\"@closeModal\"],false,[\"d-modal\",\"i18n\",\"if\",\"conditional-loading-section\",\"backup-codes\",\"html-safe\",\"d-button\"]]",
  "moduleName": "discourse/components/modal/second-factor-backup-edit.hbs",
  "isStrictMode": false
});